import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.ReceiptBankAuthModule', {
    allowAccessButton: 'Allow access',
    cancelButton: 'Cancel and go back',
    cardTitleNoCompanies: `
        You don't have any Organisations in ApprovalMax.
        Please create an Organisation and then restart the integration process.`,
    cardTitleSingleCompany: 'Dext Prepare would like to access {companyName} data',
    cardTitleMultipleCompanies: `
        Dext Prepare would like to access your data.
        Please select the organisation you want to connect with:`,
    footerText: `
        By allowing access, you agree to the transfer of your data between Dext Prepare and ApprovalMax under
        {terms} and this application's terms of use and privacy policy.
        You can disconnect this application at any time by going to Account settings in your Dext Prepare Settings.`,
    terms: 'ApprovalMax’s terms of use',
});
